export default __webpack_public_path__ + "static/media/banner-acidentes-pessoais-bem-estar-dez-2024.77404554.png";